import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectConfig, selectUserId, selectWork, selectWorks } from '../../../../Api/selectors';
import styled from 'styled-components';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_TASKS,
  REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER,
} from '../../../constants';
import { VBox, HBox } from '../../../../../components/Box';
import { VehicleInfoCard } from '../../../components/CardInfo';
import { VehicleDataCard } from '../../../components/CardData';
import { VehicleFinanceSalesCard } from '../../../components/CardFinanceSales';
import { VehicleCardCounters } from '../../../components/CardCounters';
import { VehicleFinancePurchaseCard } from '../../../components/CardFinancePurchase';
import { VehicleDocumentsCard } from '../../../components/CardDocuments';
import { VehicleLocationCard } from '../../../components/VehicleLocationCard';
import { Card } from '../../../../../components/Card';
import { Button } from '../../../../../components/Buttons';
import { VehicleBpmCard } from '../../../components/CardBPM';
import { Slider } from '../../../components/Slider';
import { VehicleDataConsumptionCard } from '../../../components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../../components/RDWandHistoryCard';
import { VehicleLabelCard } from '../../../components/CardLabel';
import { VehicleTransportCard } from '../../../components/CardTransport';
//import { VehicleHooicardtakeout } from '../components/cardHooicardtakeout';

import { VehicleExtraCostCard } from '../../../components/CardExtraCost';
import { Check, IsOpen } from '../../../../../components/Icon';
import { VehicleOutgoingInvoiceCard } from '../../../components/CardOutgoingInvoice';
import {
  deleteVehicle,
  deleteVehicleProperty,
  downloadImages,
  fetchVehicle,
  fetchVehicleTasks,
  setVehicleProperty,
} from '../../../actions';
import { VehicleWebsiteCard } from '../../../components/CardWebsite';
import { VehicleInspectionCard } from '../../../components/VehicleInspectionCard';
import { Loader } from '../../../../../components/Loader';
import { VehicleTasksCard } from '../../../components/CardVehicleTasks';
import { VehicleInvoicesCard } from '../../../components/VehcleInvoicesCard';
import { fetchVehicleInvoices } from '../../../../Invoices/actions';
import {
  REQUEST_INVOICE,
  REQUEST_INVOICE_TRADE_IN_VEHICLES,
  REQUEST_VEHICLE_INVOICES,
} from '../../../../Invoices/constants';
import { VehicleRemarksCard } from '../../../components/CardVehicleRemarks';
import { VehicleAttRemarksCard } from '../../../components/CardVehicleAttRemarks';
import { VehicleClaimCard } from '../../../components/CardClaim';
import { VehicleHexonCard } from '../../../components/CardHexon';
import { EditVehicleOptions } from '../../../pages/create/OptionsStep/EditVehicleOptions';
import { VehicleHooiInstallationPhotoCard } from '../../../components/CardHooiInstallationPhotos';

import { Permission } from '../../../../../components/Permission';
import {
  VEHICLE_REMOVE,
  VEHICLE_EDIT,
  VEHICLE_INVOICES_BUTTON,
  VEHICLE_DETAILS_BUTTON,
  VEHICLE_DOWNLOAD_IMAGES,
  VEHICLE_ACTIONS_BUTTON,
  VEHICLE_HEXON_BUTTON,
  VEHICLE_TAKEN_BUTTON,
  VEHICLE_LOGS,
  VEHICLE_EXTRA_COSTS_CRUD,
  VEHICLE_TRANSPORT_CRUD,
  VEHICLE_INSPECTION_CRUD,
  VEHICLE_DOCUMENTS_CRUD,
  PURCHASING_DATA_CRUD,
  SALES_DATA_CRUD,
  INVOICES_PAGE,
  ORB_CRUD,
} from '../../../../../components/Permission/constants';
import { VehicleOptionsCard } from '../../../components/VehicleOptionsCard';
import { PdfPreview } from '../../../components/PdfPreview';
import { WIENTJES_INSTALATION } from '../../../../../containers/App/constants';
import env from '../../../../../env';
import { PickUpStatementPdfPreview } from '../../../components/PickUpStatementPdfPreview';
import { SaleAgreementPdfPreview } from '../../../components/SaleAgreement/SaleAgreementPdfPreview';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './detailsColumns.module.css';
import { VehicleFinancialDataCard } from '../../../components/CardFinancial';
import { VehicleTestDriveCard } from '../../../components/CardVehicleTestDrive';
import { VehicleProductTasksSection } from '../../../components/VehicleProductTasksSection';
import { VehicleOutgoingProductInvoiceCard } from '../../../components/CardProductOutgoingInvoice';
import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';
import LoadingCard from '../../../../../containers/App/Components/LoadingCard/LoadingCard';
import { WS2_1_Interior } from '../../../../KanbanBoards/cells/WS/WS2_1_Interior';


//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card.wide {
    width: 99%;
  }

  .info-card-fin {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card-fin.wide {
    width: 99%;
  }

  .vehicle-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox .toggleBtn {
    margin-left: auto;
    width: 12%;
  }

  .slider-block {
    background-color: #fff;
    width: 100%;
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    border: 0px solid #dbdcdc;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07);
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;
const STATE = {
  previewType: 'interior',
  isShowExsterior: true,
  isShow: true,
  loading: false,
  IsOpen: false,
  showPickUpStatementPdfPreview: false,
  showSaleAgreementPdfPreview: false,
  showPdfPreview: false,
};

class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  componentDidMount() {
    this.timeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
    this.timeout(() => this.setState({ loadSliderAfterTimeout: true }), 800);
    this.timeout(this.props.fetchVehicleTasks, 2000);
    this.setOutgoingProductInvoiceCardData();
  }

  setOutgoingProductInvoiceCardData() {
    this.props.fetchVehicleInvoices(result => {
      if (result?.items?.length > 0) {
        console.log('Fetched Invoices:', result.items);

        const outgoingProductInvoices = result.items.filter(invoice => {
          const isOutgoing = invoice?.direction === 'outgoing';
          const isProduct = invoice?.subjectType === 'product';
          const isNotFinal = invoice?.isFinal === false;

          console.log(
            `Invoice ID: ${invoice.id}, isOutgoing: ${isOutgoing}, isProduct: ${isProduct}, isNotFinal: ${isNotFinal}`,
          );

          return isOutgoing && isProduct && isNotFinal;
        });

        console.log('Filtered outgoing product invoices:', outgoingProductInvoices);

        if (outgoingProductInvoices.length > 0) {
          const lastCreatedOutgoingProductId = outgoingProductInvoices[0]?.id;
          this.setState({ outgoingProductInvoiceId: lastCreatedOutgoingProductId });
        }
      }
    });
  }

  hideBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, previewType: 'exterior', isShow: val, loading: false }));
  }

  hideExteriorBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, isShowExsterior: val, loading: false }));
  }

  handleDelete = () => {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm('delete vehicle?')) return;
    this.props.deleteVehicle(result => {
      if (result) {
        console.log(result, 'RES');
        return this.to('/');
      }
    });
  };

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  downloadImages() {
    this.setState({ downloadingImages: true }, () => {
      this.props.downloadImages(result => {
        this.setState({ downloadingImages: false });
        window.open('/storage/zip/tmp/' + this.props.vehicle.id + '.zip');
      });
    });
  }

  renderProductInvoiceCard() {
    if (this.props.workInvoices) return <Loader small />;

    return (
      <VehicleOutgoingProductInvoiceCard
        vehicleId={this.props.vehicle.id}
        vehicle={this.props.vehicle}
        invoiceId={this.state.outgoingProductInvoiceId}
      />
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const params = new URLSearchParams(window.location.search);
    const showLinktree = params.get('showLinkTree') === 'yes';
    // || window.innerWidth <= 768
    // if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.containerPage}>
        {this.state.showPdfPreview && (
          <PdfPreview onClose={() => this.setState({ showPdfPreview: false })} vehicle={vehicle} />
        )}
        {this.state.showPickUpStatementPdfPreview && (
          <PickUpStatementPdfPreview
            onClose={() => this.setState({ showPickUpStatementPdfPreview: false })}
            vehicle={vehicle}
          />
        )}
        {this.state.showSaleAgreementPdfPreview && (
          <SaleAgreementPdfPreview onClose={() => this.setState({ showSaleAgreementPdfPreview: false })} vehicle={vehicle} />
        )}
        {/*  */}

        {/* Desktop */} {/* Desktop */} {/* Desktop */} {/* Desktop */}
        {window.innerWidth >= 768 && (
          <>
            <VBox left className={cn('col', styles.firstColumn)} top>
     
                <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
                  <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
                  <div className={styles.containerButton}>
                    <Permission permission={VEHICLE_EDIT}>
                      {/* Test Drive Actions */}
                      <WS2_1_Interior
                                                   vehicleDetails
                                                   cell={{ vehicle: this.props.vehicle }}
                                                   action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
                                                   payload={{ task_name: 'task_spray' }}
                                                   column={{ label: 'WS2_1_Interior' }}
                                                 />
                    </Permission>
                  </div>
                </Card>
           

              {/* Vehicle Information Cards */}
              <VehicleInfoCard vehicle={this.props.vehicle} />
              {this.props.workVehicle ? LoadingDetailsPageCard : <VehicleDataCard vehicle={this.props.vehicle} />}
              <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} />
              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard && <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} />}
              </Permission>
            </VBox>

            {/* Second Column */}
            <VBox left className="col" top>
              {this.state.outgoingProductInvoiceId && this.renderProductInvoiceCard()}
              <Wrapper>
                <VBox top>
                  <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
                  <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                    <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  </Permission>
                  {this.props.workTask ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    <VehicleTasksCard
                      vehicle={this.props.vehicle}
                      onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                    />
                  )}
                  <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
                  {this.props.workAttRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleAttRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                  {this.props.workTestDriveRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleTestDriveCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                </VBox>
                <VBox top>
                  {this.props.workVehicle ? <Loader small /> : <VehicleFinanceSalesCard vehicle={this.props.vehicle} />}
                  <VehicleFinancialDataCard vehicle={this.props.vehicle} />
                </VBox>
              </Wrapper>
              <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />

              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
              </Card>
              <VehicleHexonCard vehicle={this.props.vehicle} />
              <VehicleOptionsCard vehicle={this.props.vehicle} />
              <Permission permission={VEHICLE_INSPECTION_CRUD}>
                <VehicleInspectionCard vehicle={this.props.vehicle} />
              </Permission>
              <Permission permission={INVOICES_PAGE}>
                <VehicleInvoicesCard vehicle={this.props.vehicle} />
              </Permission>
            </VBox>

            {/* Third Column */}
            <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
              {window.innerWidth <= 768 && (
                <Permission permission={VEHICLE_TRANSPORT_CRUD}>
                  <VehicleTransportCard vehicle={this.props.vehicle} />
                </Permission>
              )}
              <Permission permission={VEHICLE_DOCUMENTS_CRUD}>
                <VehicleDocumentsCard vehicle={this.props.vehicle} />
              </Permission>
              {/* <VehicleLocationCard vehicle={this.props.vehicle} vehicle_details /> */}
              <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
                <h2 className="card-title mb-2 text-muted"> {this.lbl('vehicle.details.options.other')} </h2>
                <div className={styles.containerButton}>
                  <Permission permission={VEHICLE_EDIT}>
                    <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                      {this.lbl('edit')}
                    </Button>
                  </Permission>
                  <Button className={styles.button} onClick={() => this.setState({ showPdfPreview: true })}>
                    {this.lbl('vehicle.details.options.pricecard')}
                  </Button>
                  <Button
                    disabled={this.props.workOutgOrder}
                    onClick={() => this.setState({ showPickUpStatementPdfPreview: true })}
                  >
                    {this.props.workOutgOrder ? (
                      <Loader small />
                    ) : (
                      this.lbl('vehicle.details.pickup_statement.get_pick_up_statement')
                    )}
                  </Button>
                  <Button onClick={() => this.setState({ showSaleAgreementPdfPreview: true })}>
                    {this.lbl('vehicle.details.sale_agreement.generate_sale_agreement')}
                  </Button>
                  <Permission permission={VEHICLE_DETAILS_BUTTON}>
                    <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                      {this.lbl('vehicle.details.title')}
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_INVOICES_BUTTON}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/invoices`)}>
                      {this.lbl('vehicle.details.invoices.title')}
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_HEXON_BUTTON}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>
                      Hexon
                    </Button>
                  </Permission>
                  <Permission permission={ORB_CRUD}>
                    <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/oreh`)}>OREH Export</Button>
                  </Permission>
                  <Permission permission={VEHICLE_LOGS}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                      Logs
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_REMOVE}>
                    <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                      Delete
                    </Button>
                  </Permission>
                </div>
              </Card>
            </VBox>
          </>
        )}
        {/* Mobile */} {/* Mobile */} {/* Mobile */} {/* Mobile */}
        {window.innerWidth <= 768 && (
          <>
            <VBox left className={cn('col', styles.firstColumn)} top>
            <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
                  <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
                  <div className={styles.containerButton}>
                    <Permission permission={VEHICLE_EDIT}>
                      {/* Test Drive Actions */}
                      <WS2_1_Interior
                                                   vehicleDetails
                                                   cell={{ vehicle: this.props.vehicle }}
                                                   action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
                                                   payload={{ task_name: 'task_spray' }}
                                                   column={{ label: 'WS2_1_Interior' }}
                                                 />
                    </Permission>
                  </div>
                </Card>
              {showLinktree && (
                <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
                  <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
                  <div className={styles.containerButton}>
                    <Permission permission={VEHICLE_EDIT}>
                      {/* Test Drive Actions */}
                      {vehicle.task_test_drive === '0' && !vehicle.state_ac ? (
                        <Button
                          className={styles.buttonDelete}
                          warning
                          onClick={() => window.confirm('Weet je het zeker?') && this.props.setValueTestDriveAllClear('1')}
                        >
                          {this.lbl('vehicle.linktree.no_testdrive_task')}
                        </Button>
                      ) : vehicle.state_ac ? (
                        <Button className={styles.buttonDelete} warning>
                          {this.lbl('vehicle.linktree.testdrive_allready_done')}
                        </Button>
                      ) : (
                        <Button
                          className={styles.button}
                          onClick={() => window.confirm('Weet je het zeker?') && this.props.setValueTestDriveAllClear('1')}
                        >
                          {this.lbl('vehicle.linktree.testdrive_all_clear')}
                        </Button>
                      )}

                      {/* Location Actions */}
                      {vehicle.location_address_id === '5' ? (
                        <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('13584')}>
                          {this.lbl('vehicle.linktree.zet_naar_lippestraat')}
                        </Button>
                      ) : (
                        <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('5')}>
                          {this.lbl('vehicle.linktree.zet_naar_kleefstraat')}
                        </Button>
                      )}

                      {/* Second Column */}
                      <VBox left className="col" top>
                        {this.state.outgoingProductInvoiceId && this.renderProductInvoiceCard()}
                        <Wrapper>
                          <VBox top>
                            <VehicleInfoCard vehicle={this.props.vehicle} />
                            {this.props.workVehicle ? (
                              LoadingDetailsPageCard
                            ) : (
                              <VehicleDataCard vehicle={this.props.vehicle} />
                            )}
                            <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
                            
                            <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                              <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                            </Permission>
                            {this.props.workTaskRemarks || this.props.workTask ? (
                              <LoadingDetailsPageCard />
                            ) : (
                              <VehicleTasksCard
                                vehicle={this.props.vehicle}
                                onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                              />
                            )}
                                          <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />
                            
                            <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
                            {/* <VehicleProductTasksSection
                              vehicleId={this.props.vehicle?.id}
                              onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                            /> */}
                            {this.props.workAttRemarks ? (
                              <Loader small />
                            ) : (
                              <VehicleAttRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                            )}
                            {this.props.workRemarks ? (
                              <Loader small />
                            ) : (
                              <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                            )}
                            {this.props.workTestDriveRemarks ? (
                              <Loader small />
                            ) : (
                              <VehicleTestDriveCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                            )}
                          </VBox>
                          <VBox top>
                            {this.props.workVehicle ? (
                              <Loader small />
                            ) : (
                              <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
                            )}
                            <VehicleFinancialDataCard vehicle={this.props.vehicle} />
                          </VBox>
                        </Wrapper>

                        <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                          <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
                        </Card>
                        <VehicleHexonCard vehicle={this.props.vehicle} />
                        <VehicleOptionsCard vehicle={this.props.vehicle} />
                        <Permission permission={VEHICLE_INSPECTION_CRUD}>
                          <VehicleInspectionCard vehicle={this.props.vehicle} />
                        </Permission>
                        <Permission permission={INVOICES_PAGE}>
                          <VehicleInvoicesCard vehicle={this.props.vehicle} />
                        </Permission>
                      </VBox>

                      {/* Third Column */}

                      {/* Popnagels Action */}
                      {vehicle.vehicle_purpose === 'commercial' && vehicle.import === '1' && !vehicle.task_popnagels ? (
                        <Button
                          className={styles.button}
                          onClick={() =>
                            window.confirm('Popnagels afronden en €15 kosten opvoeren?') && this.props.setValuePopnagels()
                          }
                        >
                          {this.lbl('vehicle.linktree.popnagels_afronden')}
                        </Button>
                      ) : vehicle.task_popnagels ? (
                        <Button className={styles.buttonDelete} warning>
                          {this.lbl('vehicle.linktree.popnagels_afgerond')}
                        </Button>
                      ) : null}
                    </Permission>
                  </div>
                </Card>
              )}
            </VBox>

            {/* Second Column */}
            <VBox left className="col" top>
              {this.state.outgoingProductInvoiceId && this.renderProductInvoiceCard()}
              <Wrapper>
                <VBox top>
                  <VehicleInfoCard vehicle={this.props.vehicle} />
                  {this.props.workVehicle ? LoadingDetailsPageCard : <VehicleDataCard vehicle={this.props.vehicle} />}
                  <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
                  <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />
                  <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                    <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  </Permission>
                  {this.props.workTaskRemarks || this.props.workTask ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    <VehicleTasksCard
                      vehicle={this.props.vehicle}
                      onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                    />
                  )}
                  <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
                  {this.props.workAttRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleAttRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                  {this.props.workTestDriveRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleTestDriveCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                </VBox>
                <VBox top>
                  {this.props.workVehicle ? <Loader small /> : <VehicleFinanceSalesCard vehicle={this.props.vehicle} />}
                  <VehicleFinancialDataCard vehicle={this.props.vehicle} />
                </VBox>
              </Wrapper>

              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
              </Card>
              {/* <VehicleHexonCard vehicle={this.props.vehicle} /> */}
              <VehicleOptionsCard vehicle={this.props.vehicle} />
              <Permission permission={VEHICLE_INSPECTION_CRUD}>
                <VehicleInspectionCard vehicle={this.props.vehicle} />
              </Permission>
              <Permission permission={INVOICES_PAGE}>
                <VehicleInvoicesCard vehicle={this.props.vehicle} />
              </Permission>
            </VBox>

            {/* Third Column */}
            <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
              {/* {window.innerWidth <= 768 && (
                <Permission permission={VEHICLE_TRANSPORT_CRUD}>
                  <VehicleTransportCard vehicle={this.props.vehicle} />
                </Permission>
              )} */}
              <Permission permission={VEHICLE_DOCUMENTS_CRUD}>
                <VehicleDocumentsCard vehicle={this.props.vehicle} />
              </Permission>
              {/* <VehicleLocationCard vehicle={this.props.vehicle} vehicle_details /> */}
              {/* Vehicle Information Cards */}

              <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} />
              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard && <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} />}
              </Permission>
              <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
                <h2 className="card-title mb-2 text-muted"> {this.lbl('vehicle.details.options.other')} </h2>
                <div className={styles.containerButton}>
                  <Permission permission={VEHICLE_EDIT}>
                    <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                      {this.lbl('edit')}
                    </Button>
                  </Permission>
                  <Button className={styles.button} onClick={() => this.setState({ showPdfPreview: true })}>
                    {this.lbl('vehicle.details.options.pricecard')}
                  </Button>
                  <Button onClick={() => this.setState({ showPickUpStatementPdfPreview: true })}>
                    {this.lbl('vehicle.details.pickup_statement.get_pick_up_statement')}
                  </Button>
                  <Button onClick={() => this.setState({ showSaleAgreementPdfPreview: true })}>
                    {this.lbl('vehicle.details.sale_agreement.generate_sale_agreement')}
                  </Button>
                  <Permission permission={VEHICLE_DETAILS_BUTTON}>
                    <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                      {this.lbl('vehicle.details.title')}
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_INVOICES_BUTTON}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/invoices`)}>
                      {this.lbl('vehicle.details.invoices.title')}
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_HEXON_BUTTON}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>
                      Hexon
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_LOGS}>
                    <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                      Logs
                    </Button>
                  </Permission>
                  <Permission permission={VEHICLE_REMOVE}>
                    <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                      Delete
                    </Button>
                  </Permission>
                </div>
              </Card>
            </VBox>
          </>
        )}
      </Container>
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    workAttRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-attRemarks`),
    workTestDriveRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-testDriveRemarks`),
    loggedInUserId: selectUserId(),
    workTaskRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-taskRemarks`),
    workTask: selectWork(REQUEST_VEHICLE_TASKS),
    workOutgOrder: selectWorks([REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER, REQUEST_VEHICLE, REQUEST_INVOICE]),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setVehicleProperty(name, value, callback) {
      if (value === null || value === undefined) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
      }
    },
    deleteVehicle(callback) {
      dispatch(deleteVehicle(ownProps.vehicle.id, callback));
    },
    downloadImages(callback) {
      dispatch(downloadImages(ownProps.vehicle.id, callback));
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id));
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    setValueLocationAddress(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_company_id', '4'));
      // window.location.reload();
    },
    setValueTransportOutgoing() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_initiated', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_done', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_assigned_to', null));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_completed_date', 'date_today'));
      // window.location.reload();
    },
    setValuePopnagels() {
      let extra_cost_popnagels_sum = Number(ownProps.vehicle?.extra_cost_popnagels) + 15;
      let extra_cost_sum = Number(ownProps.vehicle?.extra_cost_sum) + 15;
      let extra_cost_economic_prize_sum = Number(ownProps.vehicle?.economic_prize) + 15;

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_popnagels', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_popnagels', extra_cost_popnagels_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_sum', extra_cost_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'economic_prize', extra_cost_economic_prize_sum));
    },
    setValueTestDriveAllClear(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_engine_general', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_ac', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_brakes', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_transmission', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_electrics', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_drive', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive', '0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsColumns = compose(withConnect, withRouter)(VehicleDetailsColumnsComp);
